<template>
  <div class="content">
    <!-- <div class="page-content container-fluid"></div> -->
    <b-container>
      <PageHeader :title="$t('msg-settings.header')" />
      <div class="card">
        <h5 class="card-header" v-html="$t('msg-settings.card-header')"></h5>
        <div class="card-body">
          <div class="fieldset">
            <h6>{{$t('msg-settings.start')}}</h6>
            <div>
              <input
                class="tgl tgl-light tgl-primary department-modal-change"
                id="live-active"
                type="checkbox"
              />
              <label class="tgl-btn" for="live-active"></label> {{$t('generic-str.yes')}}
            </div>
            <textarea class="form-control"></textarea>
          </div>
          <div class="fieldset">
            <h6>{{$t('msg-settings.end')}}</h6>
            <div>
              <input
                class="tgl tgl-light tgl-primary department-modal-change"
                id="live-active"
                type="checkbox"
              />
              <label class="tgl-btn" for="live-active"></label> {{$t('generic-str.yes')}}
            </div>
            <textarea class="form-control"></textarea>
          </div>
          <div class="fieldset">
            <h6>{{$t('msg-settings.expired')}}</h6>
            <div>
              <input
                class="tgl tgl-light tgl-primary department-modal-change"
                id="live-active"
                type="checkbox"
              />
              <label class="tgl-btn" for="live-active"></label> {{$t('generic-str.yes')}}
            </div>
            <textarea class="form-control"></textarea>
          </div>
          <div class="fieldset">
            <h6>{{$t('msg-settings.transfer-agent')}}</h6>
            <div>
              <input
                class="tgl tgl-light tgl-primary department-modal-change"
                id="live-active"
                type="checkbox"
              />
              <label class="tgl-btn" for="live-active"></label> {{$t('generic-str.yes')}}
            </div>
            <textarea class="form-control"></textarea>
          </div>
          <div class="fieldset">
            <h6>{{$t('msg-settings.transfer-queue')}}</h6>
            <div>
              <input
                class="tgl tgl-light tgl-primary department-modal-change"
                id="live-active"
                type="checkbox"
              />
              <label class="tgl-btn" for="live-active"></label> {{$t('generic-str.yes')}}
            </div>
            <textarea class="form-control"></textarea>
          </div>
          <div class="fieldset">
            <h6>{{$t('msg-settings.transfer-channel')}}</h6>
            <div>
              <input
                class="tgl tgl-light tgl-primary department-modal-change"
                id="live-active"
                type="checkbox"
              />
              <label class="tgl-btn" for="live-active"></label> {{$t('generic-str.yes')}}
            </div>
            <textarea class="form-control"></textarea>
          </div>
        </div>
        <div class="card-footer">
          <button class="btn btn-primary">{{$t('generic-str.save')}}</button>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/PageHeader.vue';

export default {
  name: 'MessagesSettings',
  components: {
    PageHeader,
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  },
};
</script>
<style scoped lang="scss">
.tgl-btn {
  display: inline-block;
  vertical-align: middle;
  margin: 0 .8em 0 0;
}

h6 {
  font-weight: bold;

  & + div {
    padding-bottom: 1.5em;
  }
}

.fieldset {
  padding: 1.5em;
}

.page-header::v-deep {
  padding: 30px 0;
}

.form-control {
  min-height: 100px;
}
</style>
